package com.cybersoftsolution.cybersoftsolutionweb.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.CloseButtonX
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyBorderRadius
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonNew
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyLoadingButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonVariant
import com.cybersoftsolution.cybersoftsolutionweb.components.capcha.SliderCaptchaBootstrap
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyIcons
import com.cybersoftsolution.cybersoftsolutionweb.components.text.MySpanText
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.models.SignUpParams
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.isValidInt
import com.cybersoftsolution.cybersoftsolutionweb.styles.GoogleButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.LoginStyle
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.signUpUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.confirmNewPasswordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.googleAuthButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.newPasswordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.otpExpireInSecTextId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.otpTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.registerButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.userEmailTextField
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.userNameTextField
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.VerticalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Form
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLInputElement

@Composable
inline fun SignUpDialog(
    rootModifier: Modifier = Modifier,
    breakpoint: Breakpoint,
    scope: CoroutineScope,
    context: PageContext,
    userEmail: String,
    userName: String,
    captchaVerified: Boolean = false,
    newPassword: String?,
    confirmNewPassword: String?,
    otpCode: String?=null,
    errorText: String = " ",
    crossinline setUserName: (String) -> Unit,
    crossinline setEmail: (String) -> Unit,
    crossinline setOtpCode: (String?) -> Unit,
    crossinline setNewPassword: (String?) -> Unit,
    crossinline setConfirmNewPassword: (String?) -> Unit,
    crossinline setErrorText: (String) -> Unit,
    crossinline setCaptchaVerified: (Boolean) -> Unit,
    crossinline onClose: () -> Unit,
    crossinline onGoogleAuthButtonClick: () -> Unit,
    crossinline onSignInButtonClick: () -> Unit,
    crossinline onRegisterComplete:() -> Unit,
    crossinline onRegisterSuccess:(successMessage:String?) -> Unit,
    crossinline onRegisterFail:(errorMessage:String?) -> Unit,
) {

    var registerButtonLoading by remember{ mutableStateOf(false) }
    var step by remember { mutableStateOf(1) }
    var otpExpireInSec:Int by remember { mutableStateOf(0) }


    LaunchedEffect(otpExpireInSec) {
        if (otpExpireInSec > 0) {
            delay(1000)
            otpExpireInSec -= 1
        }
    }

    LaunchedEffect(step) {
        if (step==-1) {

            delay(50)
            onRegisterComplete()
            step = 1
        }


    }



    Box(
        contentAlignment = Alignment.TopStart,
        modifier = Modifier
            .thenIf(
                condition = breakpoint <= Breakpoint.SM,
                other = Modifier
                    .fillMaxWidth(95.percent)
//                    .height(95.percent)
            )
            .thenIf(
                condition = breakpoint == Breakpoint.MD,
                other = Modifier.width(500.px)
            )
            .thenIf(
                condition = breakpoint > Breakpoint.MD,
                other = Modifier.width(500.px)
            )
            .backgroundColor(Theme.LightGray.rgb)
            .borderRadius(15.px)
            .zIndex(80)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .overflow(Overflow.Auto)
            .scrollBehavior(ScrollBehavior.Smooth)
            .then(rootModifier)


    ) {
        Column(
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .fillMaxSize()
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
        ) {
            Row(
                horizontalArrangement = Arrangement.End,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.px)
            ) {
                CloseButtonX(
                    onClick = { onClose() }
                )
            }

            MyButtonNew(
                modifier = Modifier
                    .margin(top = 20.px)
                    .height(60.px)
                    .minHeight(60.px)
                    .width(90.percent),
                style = GoogleButtonStyle,
                id = googleAuthButtonId,
                borderRadius = 15.px,
                text = "Registrarme con Google",
//                faIconsClassName = Resources.FaIconsClassName.Register_User_ICO,
                image = {
                    Image(
                        modifier = Modifier
                            .fillMaxHeight(80.percent)
                            .backgroundColor(Theme.Withe.rgb)
                            .padding(5.px)
                            .borderRadius(15.px),
//                            .aspectRatio(1)
//                            .objectFit(ObjectFit.Cover),
                        src = Resources.Images.google,
                        alt = "Google Ico"
                    )
                },
                fontSize = 18,
                onClick = {
                    onGoogleAuthButtonClick()
                }
            )



            MySpanText(
                text = "Registrate usando una dirección de correo electrónico válida",
                fontColor = Theme.HalfBlack.rgb,
                fontSize = 16,
                modifier = Modifier
                    .textAlign(TextAlign.Center)
                    .margin(top = 20.px)
            )

            Column(
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.Start,
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .padding(20.px)
                    .margin(top = 20.px)
                    .backgroundColor(Theme.LightDarkGray.rgb)
                    .borderRadius(10.px)
            ) {


                if (step==1){
                    Form(
                        attrs = Modifier
                            .fillMaxWidth()
                            .toAttrs {  }
                    ) {

                        MyTextField(
                            id = userNameTextField,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = userName,
//                        autoComplete = AutoComplete.name,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Text,
                            placeholder = "Nombre Completo",
                            onChange = { setUserName(it) },
                            onEnter = {
                                (document.getElementById(userEmailTextField) as HTMLButtonElement).focus();
                            }

                        )

                        MyTextField(
                            id = userEmailTextField,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = userEmail,
//                        autoComplete = AutoComplete.email,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Text,
                            placeholder = "Correo electrónico",
                            onChange = {
                                setEmail(it)
                                setCaptchaVerified(false)
                            },
                            onEnter = {
                                (document.getElementById(registerButtonId) as HTMLButtonElement).focus();
                            }

                        )

                        SliderCaptchaBootstrap(
                            verified = captchaVerified,
                            useErrorMessages = false,
                            modifier = Modifier
                                .margin(bottom = 24.px),
                            onVerified = {
                                setCaptchaVerified(true)
                            },
                            onError = { errorMessage ->
                                setCaptchaVerified(false)
//                            scope.launch {
//                                showTemporaryTextMessage( errorMessage){setErrorText(it)}
//                            }
                            }
                        )


                    }
                }


                if (step==2){
                    Form(
                        attrs = Modifier
                            .fillMaxWidth()
                            .toAttrs {  }
                    ) {

                        MyTextField(
                            enabled = if ( otpExpireInSec > 0) false else true,
                            id = userEmailTextField,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = userEmail,
//                        autoComplete = AutoComplete.email,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Text,
                            placeholder = "Correo electrónico",
                            onChange = {
                                setEmail(it)
                                setCaptchaVerified(false)
                            },
                            onEnter = {
                                (document.getElementById(registerButtonId) as HTMLButtonElement).focus();
                            }

                        )

                        Column(
                            modifier = Modifier
                                .margin(bottom = 24.px)
                        ) {
                            MyTextField(
                                id = otpTextFieldId,
                                modifier = Modifier
                                    .fillMaxWidth()

                                    .height(50.px)
                                    .padding(leftRight = 10.px)
                                    .margin(bottom = 8.px)
                                    .fontSize(16.px)
                                    .borderRadius(10.px)
                                ,
                                maxLength = 6,
                                text = otpCode,
                                autoComplete = AutoComplete.oneTimeCode,
                                style = LoginStyle,
                                inputTypeHTML = InputTypeHTML.Text,
                                //                        id = otpTextField,
                                placeholder = "Codigo de Verificacion",
                                onChange = {
                                    if (it.isValidInt()) setOtpCode(it) else setOtpCode(null)
                                },
                                onEnter = {
                                    (document.getElementById(registerButtonId) as HTMLInputElement).focus();
                                }

                            )

                            SpanText(
                                text = if (otpExpireInSec > 0) "El código de verificación expirará en $otpExpireInSec segundo/s" else "Tiempo agotado, solicite nuevamente",
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .textAlign(TextAlign.Justify)
                                    .id(otpExpireInSecTextId)
                                    .color(if (otpExpireInSec > 0) Theme.HalfBlack.rgb else Colors.Red)
                                    .fontWeight(FontWeight.Normal)
                                    .fontSize(FontSize.Small)

                            )
                        }




                    }
                }

                if (step==3){
                    Form(
                        attrs = Modifier
                            .fillMaxWidth()
                            .toAttrs {  }
                    ) {

                        MyTextField(
                            id = newPasswordTextFieldId,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = newPassword,
//                        autoComplete = AutoComplete.name,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Password,
                            placeholder = "Establezca su contraseña",
                            onChange = { setNewPassword(it) },
                            onEnter = {
                                (document.getElementById(confirmNewPasswordTextFieldId) as HTMLButtonElement).focus();
                            }

                        )

                        MyTextField(
                            id = confirmNewPasswordTextFieldId,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = confirmNewPassword,
//                        autoComplete = AutoComplete.email,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Password,
                            placeholder = "Confirme su contraseña",
                            onChange = {
                                setConfirmNewPassword(it)
                            },
                            onEnter = {
                                (document.getElementById(registerButtonId) as HTMLButtonElement).focus();
                            }

                        )

                    }
                }


                MyLoadingButton(
                    id = registerButtonId,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(50.px)
                    ,
                    disabled = !captchaVerified,
                    text = when (step) {
                        1 -> if (captchaVerified) "Solicitar OTP" else "Resuelve el Captcha"
                        2 -> { if (otpExpireInSec > 0) {
                            "Continuar"
                        } else "Solicitar OTP"
                        }
                        else -> "Finalizar Registro"
                    },
                    variant = when (step) {
                        1 -> MyButtonVariant.Success
                        2 -> { if (otpExpireInSec > 0) {
                            MyButtonVariant.Success
                        } else MyButtonVariant.Danger
                        }
                        else -> MyButtonVariant.Success
                    },
//                    variant =  if (otpExpireInSec > 0 && step==2) MyButtonVariant.Success else MyButtonVariant.DangerOutline,
//                    customization = MyButtonCustomization(
//
//                    ),
                    borderRadius = MyBorderRadius(15.px),
                    icon = when (step) {
                        1 -> MyIcons.ENVELOPE_AT_FILL
                        2 -> { if (otpExpireInSec > 0) {
                            MyIcons.ENVELOPE_CHECK_FILL
                        } else MyIcons.ENVELOPE_AT_FILL
                        }
                        else -> MyIcons.BOX_ARROW_IN_RIGHT
                    },
//                    icon = if (otpExpireInSec > 0) MyIcons.BOX_ARROW_IN_RIGHT else MyIcons.UPC,
                    loading = registerButtonLoading,
                    onClick = {

                        if (!captchaVerified) {
                            return@MyLoadingButton
                        }


                        if (step==3) {
                            if (newPassword.isNullOrEmpty()) {
                                onRegisterFail("Por favor ingrese una contraseña")
                                return@MyLoadingButton
                            }
                            if (confirmNewPassword.isNullOrEmpty()) {
                                onRegisterFail("Confirme su contraseña")
                                return@MyLoadingButton
                            }
                            if (newPassword != confirmNewPassword) {
                                onRegisterFail("Las contraseñas no coinciden")
                                return@MyLoadingButton
                            }
                        }

                        registerButtonLoading = true

                        scope.signUpUseCase(
                            step = step,
                            setStep = {
                                step = it
                            },
                            refreshOtpExpireInSec = { it ->
                                otpExpireInSec = it?.toInt() ?: 0
                            },
                            signUpParams = SignUpParams(
                                name = userName,
                                email = userEmail,
                                otp = when (step) {
                                    1 -> otpCode?.toInt()
                                    2 -> { if (otpExpireInSec > 0) {
                                        otpCode?.toInt()
                                    } else null
                                    }
                                    else -> otpCode?.toInt()
                                },
                                password = when (step) {
                                    3 -> newPassword.orEmpty()
                                    else -> null
                                },
                            ),
                            setErrorText = {
//                                setErrorText(it)
                                onRegisterFail(it)
                            },
                            onSuccess = { successMessage ->
                                registerButtonLoading = false
                                onRegisterSuccess(successMessage)
                            },
                            onFail = { errorMessages ->
//                                console.log("Sign Error message: $errorMessages")
                                registerButtonLoading = false
                                onRegisterFail(errorMessages)

                            }
                        )


                    }
                )

                SpanText(
                    text = errorText,
                    modifier = Modifier
                        .fillMaxWidth()
                        .textAlign(TextAlign.Center)
                        .id(errorText)
                        .color(Colors.Red)
                        .padding(leftRight = 24.px)
//                        .margin(bottom = 24.px)
                        .fontWeight(FontWeight.Light)
                        .fontSize(FontSize.Medium)

                )


            }



            MySpanText( //aun no tienes una cuenta
                text = "Si ya tienes una cuenta, Inicia Sesión y si olvidaste tu contraseña, haz clic en Restabelecer contraseña",
                fontColor = Theme.HalfBlack.rgb,
                fontSize = 15,
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .textAlign(TextAlign.Center)
                    .margin(top = 20.px)
            )

                MyButton(
                    id = "loginButtonId",
                    text = "Iniciar Sesión",
                    fontSize = 18,
                    buttonType = MyButtonType.Primary,
                    modifier = Modifier
                        .margin(top = 20.px)
                        .height(60.px)
                        .minHeight(60.px)
                        .width(90.percent)
                        .borderRadius(15.px)
                        .margin(bottom = 24.px, top = 12.px),

                    onClick = {
                        onSignInButtonClick()
                    }

                )


            FooterSectionDialog()





        }
    }
}